import { useState } from 'react';
import { Title } from 'components/Title';

import PDFViewerWithInput from './PDFViewerWithInput'
export default function PdfviewerwithinputPage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="PdfviewerwithinputPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title="PDFViewerWithInput"   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <PDFViewerWithInput/>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
